import $ from 'jquery'

$('[data-patterns]').each(function () {
  const navSel = '.patterns-nav'
  const listSel = '.patterns-list'
  const dataSel = 'script.patterns-data'
  const itemSel = '.swatch'
  const linkSel = '.btn'

  const $nav = $(this).find(navSel)
  const $list = $(this).find(listSel)
  const $data = $(this).find(dataSel)
  const $input = $list.find('input')

  const data = ($data[0] && $data[0].text && JSON.parse($data[0].text)) || []
  const itemsPerPage = $list.find(itemSel).length
  const numPages = Math.ceil(data.length / itemsPerPage)
  let currentPage = 0

  function getSelectedId() {
    return $input.val()
  }

  function jumpTo(pg) {
    const page = ((pg % numPages) + numPages) % numPages
    const offset = itemsPerPage * page
    const activeId = getSelectedId()

    // update background images
    $list.find(itemSel).each(function (i) {
      const $this = $(this)
      const item = data[i + offset]
      const itemId = (item && item.id) || 0 // not undefined
      const imageUri = item && item.image_uri
      const background = imageUri ? 'url(' + imageUri + ')' : 'transparent'

      // N.B. passing undefined here will not remove the id!
      $this.data('id', itemId)
      $this.css('background', background)

      // disable unused items
      if (itemId) {
        $this.removeClass('disabled')
      } else {
        $this.addClass('disabled')
      }

      // tag active item
      // N.B. use == b/c we may be comparing a string and number here.
      if (itemId && itemId == activeId) { // eslint-disable-line eqeqeq
        $this.addClass('active')
      } else {
        $this.removeClass('active')
      }
    })

    // enable/disable some links
    $nav.find('[data-page=0]').disabled(page === 0)
    $nav.find('[data-page=-1]').disabled(page === numPages - 1)

    // update current page
    currentPage = page
  }

  // Update selection on click
  $list.on('click', itemSel, function () {
    const $item = $(this)
    const itemId = $item.data('id')

    // ignore disabled items and missing ids
    if ($item.is('.disabled') || !itemId) {
      return false
    }

    // select item id unless disabled
    $input.val(itemId)
    $item.siblings().removeClass('active')
    $item.addClass('active')
  })

  // Handle nav links
  $nav.on('click', linkSel, function (evt) {
    const $link = $(this)
    const page = $link.data('page')
    const pageAdd = $link.data('page-add')

    // always prevent default
    evt.preventDefault()

    // ignore disabled links
    if ($link.parent().is('.disabled')) {
      return false
    }

    // handle first, last, and indexed page links
    if (typeof page !== 'undefined') {
      return jumpTo(page)
    }

    // handle prev and next links
    if (typeof pageAdd !== 'undefined') {
      return jumpTo(currentPage + pageAdd)
    }
  })

  function findIndex(id) {
    let idx = -1
    $.each(data, (i, v) => {
      // N.B. use == b/c we may be comparing a string and number here.
      if (v.id == id) { // eslint-disable-line eqeqeq
        idx = i
        return false
      }
    })
    return idx
  }

  function findPage(id) {
    const idx = findIndex(id)
    return Math.floor(idx / itemsPerPage)
  }

  function findSelectedPage() {
    return findPage($input.val())
  }

  function jumpToSelected() {
    const pg = findSelectedPage()
    if (pg < 0) {
      jumpTo(0)
    } else {
      jumpTo(pg)
    }
  }

  // init
  jumpToSelected()
})
